import React, { ReactNode, useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { theme } from 'src/styles/theme';

import Start2 from "src/assets/icons/octicon_sparkle-fill-16.svg";
import Start1 from "src/assets/icons/oui_sparkle-filled.svg";
import { Avatar } from 'src/components/Avatar';
import { useBoundStore } from 'src/store';
import { useNavigate } from 'react-router-dom';
import Loader from "src/components/Loader";
import toast from 'react-hot-toast';

// Define the props interface for our component
interface IndexedVideo {
    index: number;
    video: any;
    duration?: number
}
interface PublishQcastStudioProps {
  questions: any[];
  videos: IndexedVideo[];
}

// Styled Components
const Container = styled.div`
    width: 100%;
    // height: 700px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 30px;
    color: #000;
    // padding: 40px 40px 0px 40px;
    // background: red;

    
`;

const ContentArea = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
  justify-content: center;
  padding: 40px;
`;


const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  align-items: center;
`;

const Title = styled.div`
  font-family: ${theme.fonts.secondary};
  font-weight: ${theme.fontWeights.bold};
  font-size: ${theme.fontSizes.xxxxxl};
  line-height: 100%;
  letter-spacing: -2%;
  text-align: center;
`;

const SubTitle = styled.div`
  font-family: ${theme.fonts.secondary};
  font-weight: ${theme.fontWeights.medium};
  font-size: ${theme.fontSizes.xxli};
  line-height: 100%;
  letter-spacing: -2%;
  text-align: center;
`;

const ProfileBox = styled.div`
  width: 414px;
  height: 200px;
  border-radius: 320px;
  gap: 0px;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const ImageBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
`;
const IconBox = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

const FormContainer = styled.div`
  width: 100%;
  height: auto;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 30px;
  background: #FFFFFF;
  box-shadow: 0px 6px 60px 0px #00000014;

  box-shadow: 0px 4px 64px 0px #FFFFFF1F inset;
  .headers{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: start;
    gap: 8px;

    .title{
      font-family: ${theme.fonts.primary};
      font-weight: ${theme.fontWeights.bold};
      font-size: ${theme.fontSizes.xxl};
      line-height: 130%;
      letter-spacing: 0%;
    }
    .subtitle{
      font-family: ${theme.fonts.primary};
      font-weight: ${theme.fontWeights.regular};
      font-size: ${theme.fontSizes.base};
      line-height: 130%;
      letter-spacing: 0%;
      color: var(--Grey-757575, #757575);
    }
  }
  
  .content{
    width: 100%;
    height: 86px;
    gap: 30px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .actions{
      width: 100%;
      height: 41px;
      display:flex;
      gap: 10px;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
    }

    @media(max-width: ${theme.breakpoints.mobile}px) {
      flex-direction: column;
      height: auto;
    }
  }
`;

const FormControl = styled.div`
  width: 50%;
  height: 86px;
  gap: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;

  @media(max-width: ${theme.breakpoints.mobile}px) {
    width: 100%;
  }
`;

const Label = styled.h3`
  font-family: ${theme.fonts.primary};
  font-weight: ${theme.fontWeights.semiBold};
  font-size: ${theme.fontSizes.lg};
  line-height: 130%;
  letter-spacing: 0%;
  color: #282828;
  span{
    font-family: ${theme.fonts.primary};
    font-weight: 600;
    font-size: 18px;
    line-height: 130%;
    letter-spacing: 0%;
  }
`;
const Input = styled.input`
  width: 100%;
  height: 51px;
  border-radius: 10px;
  padding: 20px 16px;
  gap: 10px;
  border-width: 1px;
  background: #190F4908;
  border: 1px solid #0000001F
`

const ACtionButton = styled.button`
  width: 86px;
  height: 41px;
  border-radius: 100px;
  padding-top: 12px;
  padding-right: 20px;
  padding-bottom: 12px;
  padding-left: 20px;
  gap: 20px;
  background: var(--Abyss, #190F49);
  color: #fff;


  font-family: ${theme.fonts.primary};
  font-weight: ${theme.fontWeights.medium};
  font-size: ${theme.fontSizes.md};
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
`;

const ControlButtons = styled.div`
  width: 340px;
  height: 39px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 24px;

  .flatButton{
    font-family: ${theme.fonts.primary};
    font-weight: ${theme.fontWeights.semiBold};
    font-size: ${theme.fontSizes.base};
    line-height: 135%;
    letter-spacing: 0%;
    color: #000000;
  }
  .actionButton{
    width: 213px;
    height: 39px;
    border-radius: 50px;
    padding: 10px 20px;
    gap: 10px;
    background: var(--Discovery-Purple, #5F15D7);
    color: #fff;

    font-family: ${theme.fonts.primary};
    font-weight: ${theme.fontWeights.semiBold};
    font-size: ${theme.fontSizes.base};
    line-height: 100%;
    letter-spacing: 0%;
    vertical-align: middle;

  }

  @media(max-width: ${theme.breakpoints.mini}px) {
    width: 100%;
    flex-direction: column;
    margin-bottom: 20px;
  }
`;
// Main component
const PublishQCastStudio: React.FC<{avaterSrc?: string, qcastId: string, userId: string, interviewId: string, onUpdate: (detail: any) => Promise<any>}> = ({avaterSrc, qcastId, userId, interviewId, onUpdate}) => {

  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [firstname, setFirstname] = useState<string>("");
  const [lastName, setaLastname] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
    
  const { clearQcasts } = useBoundStore();

  const navigate = useNavigate();

  const handleAction = async () => {
    if(!firstname || !lastName || !email){
      toast.error("First name, Last name and Email cannot be empty.")
      return;
    }

 
    const response: any = await onUpdate({
      interviewId,
      name: `${firstname} ${lastName}`,
      email,
      phone
    })
    if(response){
      await clearQcasts();
      setFirstname("");
      setaLastname("");
      setEmail("");
      setPhone("");
      setIsLoading(false);  
    }
    
  };
  
  

  return (
    <Container>
        {isLoading && (<Loader />)}
        <ContentArea>
          <HeaderText>
            <SubTitle>Thank you for participating!</SubTitle>
            <Title>Your Qcast response has been published!</Title>
          </HeaderText>
          <ProfileBox>
            <img src={Start1} />
            <ImageBox>
              <Avatar src={avaterSrc}  size={200} />
            </ImageBox>
            <IconBox>
              <img src={Start1} />
              <img src={Start2} />
            </IconBox>
          </ProfileBox>

          <FormContainer>
            <div className="headers">
              <div className='title'>Let us get back to you on your responses!</div>
              <div className='subtitle'>Fill up your details and we’ll get back to you soon.</div>
            </div>
            <div className='content'>
              <FormControl>
                <Label>First Name</Label>
                <Input onChange={(e: any)=>setFirstname(e.target.value)} value={firstname}/>
              </FormControl>
              <FormControl>
                <Label>Last Name</Label>
                <Input onChange={(e: any)=>setaLastname(e.target.value)} value={lastName}/>
              </FormControl>
            </div>
            <div className='content'>
              <FormControl>
                <Label>Email</Label>
                <Input type="email" onChange={(e: any)=>setEmail(e.target.value)} value={email}/>
              </FormControl>
              <FormControl>
                <Label>Phone Number <span>(Optional)</span></Label>
                <Input onChange={(e: any)=>setPhone(e.target.value)} value={phone} />
              </FormControl>
            </div>
            <div className='content'>
              <div className='actions'>
                <ACtionButton onClick={handleAction}>Submit</ACtionButton>
              </div>
            </div>
          </FormContainer>
          <ControlButtons>
            <button className='flatButton' onClick={async() => {
              await clearQcasts();
            window.location.href=process.env.REACT_APP_MAIN_URL;}} >Back to Home</button>
            <button onClick={async() => {
              await clearQcasts();
            navigate(`/?qcastId=${localStorage.getItem("qcastId")}&userId=${localStorage.getItem("userId")}`);}} className='actionButton'>Make another response</button>
          </ControlButtons>
        </ContentArea>
        
    </Container>
  );
};

export default PublishQCastStudio;